import React from 'react';

const PaymentContext = React.createContext();

export default PaymentContext;
